import React from 'react';
import { Box } from '@mui/material';

interface FantasySportsLogoProps {
  width?: number;
  height?: number;
  onDark?: boolean;
}

export const FantasySportsLogo: React.FC<FantasySportsLogoProps> = ({ 
  width = 32, 
  height = 32, 
  onDark = false 
}) => {
  const zoneColor = onDark ? '#ffffff' : '#000000';
  
  // Different pitch type colors
  const fastballColor = onDark ? '#ff6b6b' : '#e74c3c';      // Red
  const curveballColor = onDark ? '#4ecdc4' : '#27ae60';     // Green
  const sliderColor = onDark ? '#45b7d1' : '#3498db';        // Blue
  const changeupColor = onDark ? '#f9ca24' : '#f39c12';      // Orange
  
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: width,
        height: height,
        borderRadius: '50%',
        backgroundColor: onDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(25, 118, 210, 0.1)',
        overflow: 'hidden',
      }}
    >
      <svg
        width={width * 0.8}
        height={height * 0.8}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Strike zone rectangle */}
        <rect
          x="25"
          y="20"
          width="50"
          height="60"
          fill="none"
          stroke={zoneColor}
          strokeWidth="2"
          rx="2"
        />
        
        {/* Different pitch types with different colors */}
        {/* Fastballs (red) */}
        <circle cx="35" cy="30" r="3" fill={fastballColor} />
        <circle cx="65" cy="35" r="3" fill={fastballColor} />
        
        {/* Curveballs (green) */}
        <circle cx="45" cy="50" r="3" fill={curveballColor} />
        <circle cx="30" cy="70" r="3" fill={curveballColor} />
        
        {/* Sliders (blue) */}
        <circle cx="55" cy="65" r="3" fill={sliderColor} />
        <circle cx="70" cy="75" r="3" fill={sliderColor} />
        
        {/* Changeups (orange) */}
        <circle cx="20" cy="40" r="2" fill={changeupColor} opacity="0.8" />
        <circle cx="80" cy="60" r="2" fill={changeupColor} opacity="0.8" />
        <circle cx="40" cy="85" r="2" fill={changeupColor} opacity="0.8" />
      </svg>
    </Box>
  );
};
